import app from "/src/app/app.module";
import './dashboard.html'
import moment from "moment";

app.controller('dashboard', function ($scope, settings, $filter, $job, vxUtils,
                                      $api, $auth, $users,
                                      selectionFilters, tabService, $order) {
    $scope.openItems = tabService.tabs;
    $scope.PageHash = vxUtils.generateQuickGuid();

    $scope.init = function () {
        $scope.lastdate = {
            startDate: moment().startOf('day').unix(),
            endDate: moment().add('days', 7).unix()
        };
        $scope.getItems($scope.lastdate);

        $scope.timeLineCpi = {
            tabItems: $scope.openItems,
            filters: selectionFilters.jobStatesFn($scope.companies),
            fields: [{
                field: 'status', expression: function (value) {
                    return {
                        status: value.state
                    };
                }
            }, {
                field: 'crewstatus', expression: function (value) {
                    return {
                        crewstatus: value.state
                    };
                }
            }]
        };

        $scope.notificationCpi = {
            tabItems: $scope.openItems,
            filters: [],
            fields: []
        };
    };


    $scope.timeLineOrderCpi = {
        tabItems: $scope.openItems,
        filters: selectionFilters.orderStates,
        fields: [{
            field: 'status', expression: function (value) {
                return {
                    status: value.state
                };
            }
        }]
    };

    function getNotifications() {
        $users.getNotifications(function (results) {
            $scope.notifications = $filter('orderBy')(results, 'executiondate');
            $scope.notificationCpi.all = $scope.notifications;
            if ($scope.notificationCpi.refresh)
                $scope.notificationCpi.refresh();
        });
    }

    $scope.getItems = function (date) {
        $scope.lastdate = date;


            $scope.notifications = [];
            getNotifications();
            setInterval(getNotifications, 60*1000);


        $job.getJobsBetween(function (results) {
            $scope.timeLineCpi.all = results;

            if ($scope.timeLineCpi.refresh)
                $scope.timeLineCpi.refresh();
            var ids = $filter('map')($scope.timeLineCpi.all, 'jobid');
            $job.getEmailConfirmations(function (data) {
                for (var i = 0; i < $scope.timeLineCpi.all.length; i++) {
                    var item = $scope.timeLineCpi.all[i];
                    var mail = $filter('filter')(data, {
                        vox_mail_referenceID: item.jobid.toString()
                    })[0];
                    if (mail === undefined)
                        continue;

                    item.isread = mail.vox_mail_logging_date_read;
                    item.mail = mail;
                    item.isconfirmed = mail ? true : false;
                    item.isconfirmedicon = item.isConfirmedIcon();
                }

            }, ids);
        }, date.startDate, date.endDate);

        $scope.lastdateOrders = {
            startDate: moment().subtract(14, 'days').unix(),
            endDate: moment().add(1, 'days').unix()
        };

        $order.getAllOrders($scope.lastdateOrders.startDate, $scope.lastdateOrders.endDate, function (results) {
            $scope.timeLineOrderCpi.all = results;
            if ($scope.timeLineOrderCpi.refresh)
                $scope.timeLineOrderCpi.refresh();
        });
    };
    $scope.scrollMethod = function ($event, $delta, $deltaX, $deltaY) {
        vxUtils.scrollHorzontal($event, $delta, $deltaX, $deltaY, $scope.PageHash);
    };

    $auth.getAllCompanies(function (result) {
        $scope.companies = result;
        $scope.init();
    }, true);
});
